// src/components/campaign/AiBodyScanner.jsx

import { motion } from "framer-motion";
import Tilt from "react-parallax-tilt";
import FloatingMetric from "./FloatingMetric";

export default function AiBodyScanner() {
  return (
    <div className="relative mx-auto h-[390px] max-w-[360px]">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 30, ease: "linear" }}
        className="absolute inset-8 rounded-full border border-emerald-300/10"
      />
      <motion.div
        animate={{ rotate: -360 }}
        transition={{ repeat: Infinity, duration: 38, ease: "linear" }}
        className="absolute inset-16 rounded-full border border-blue-400/10"
      />

      <div className="absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-emerald-400/10 blur-3xl" />
      <div className="absolute left-1/2 top-1/2 h-52 w-52 -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-500/10 blur-3xl" />

      <Tilt
        tiltMaxAngleX={10}
        tiltMaxAngleY={10}
        glareEnable
        glareMaxOpacity={0.22}
        scale={1.03}
        className="relative z-10 mx-auto w-[230px]"
      >
        <div className="relative mx-auto h-[370px] w-[210px] overflow-hidden rounded-[38px] border border-white/15 bg-black p-2 shadow-[0_0_120px_rgba(16,185,129,.34)]">
          <div className="absolute left-1/2 top-2 z-20 h-5 w-20 -translate-x-1/2 rounded-b-2xl bg-black" />

          <div className="relative h-full overflow-hidden rounded-[30px] bg-[#0b1020]">
            <img
              src="/images/app-preview.png"
              alt="پیش‌نمایش برنامه موجیم"
              className="h-full w-full object-cover opacity-90"
            />

            <div className="absolute inset-0 bg-gradient-to-b from-emerald-400/10 via-transparent to-blue-500/15" />

            <motion.div
              animate={{ y: ["-30%", "120%"] }}
              transition={{ repeat: Infinity, duration: 2.8, ease: "easeInOut" }}
              className="absolute left-0 right-0 h-24 bg-gradient-to-b from-transparent via-emerald-300/30 to-transparent"
            />

          </div>
        </div>
      </Tilt>

      <FloatingMetric className="right-1 top-12" label="BMI" value="در حال تحلیل" delay={0} />
      <FloatingMetric className="left-0 top-24" label="هدف" value="اختصاصی" delay={0.4} />
      <FloatingMetric className="right-2 bottom-24" label="برنامه" value="تمرین + تغذیه" delay={0.8} />
      <FloatingMetric className="left-2 bottom-14" label="اصلاح رایگان" value="تا ۲۴ ساعت" delay={1.1} />

      <div className="absolute bottom-2 left-1/2 z-20 flex -translate-x-1/2 items-center gap-2 rounded-full border border-white/10 bg-black/35 px-4 py-2 text-[10px] text-white/65 backdrop-blur-2xl">
        <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-300 shadow-[0_0_14px_rgba(52,211,153,.9)]" />
        آماده‌سازی تحلیل هوشمند
      </div>
    </div>
  );
}